import React, { useEffect, useState } from "react";
import "./message.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Checkbox,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const StatusCodeDrawer = ({
  getStatusCode,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px"; // For extra small screens (mobile), set width to full screen width
  } else if (isSm) {
    drawerWidth = "300px"; // For small screens, set width to half of the screen
  } else if (isMd) {
    drawerWidth = "400px"; // For medium screens, set width to half of the screen
  } else if (isLg) {
    drawerWidth = "600px"; // For large screens, set width to half of the screen
  } else if (isXl) {
    drawerWidth = "600px"; // For extra large screens, set width to half of the screen
  }

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const createNewStatusCode = () => {
    const message_status_name = information?.message_status_name?.trim();
    const message_status_desc = information?.message_status_desc?.trim();
    if ( message_status_name.length == 0) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 4000);
      return;
    }
    const body = {
      message_status_id: information?.message_status_id,
      message_status_name: information?.message_status_name,
      message_status_desc: information?.message_status_desc,
      is_notifiable: information?.is_notifiable,
    };
    setBackDrop(true);
    instance
      .post("api/v1/Master/MessageStatus/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getStatusCode();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if(type === "Add")
        {
        setInformation({
          message_status_name:"",
          message_status_desc:""
        })
      }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  const onChanageHandler = (event) => {
    const { id, value, type } = event?.target;
    if (type == "checkbox") {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: event?.target?.checked == true ? 1 : 0,
        };
      });
    } else {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: value,
        };
      });
    }
  };
  useEffect(() => {
    setInformation({
      message_status_id: filledInfo?.message_status_id ?? 0,
      message_status_name: filledInfo?.message_status_name ?? "",
      message_status_desc: filledInfo?.message_status_desc ?? "",
      is_notifiable: filledInfo?.is_notifiable ?? 0,
    });
  }, [drawerCaller]);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      //   onClose={handleDrawerClose}
      PaperProps={{
        sx: {
          width: drawerWidth, // Set the width dynamically
        },
      }}
    >
      <div
        style={{ padding: "20px" }}
        // onClick={handleDrawerClose}
        // onKeyDown={handleDrawerClose}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backmsg"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon  onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colormsg mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Message Status{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colormsg mb-1"
              style={{ fontWeight: "600" }}
            >
              Message Status Information{" "}
            </Typography>
          </Grid>
          {/* alert */}
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_status_name"> Status Name <span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="message_status_name"
              size="small"
              value={information?.message_status_name}
              onChange={onChanageHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="message_status_desc">
              Status Description
            </InputLabel>
            <TextField
              id="message_status_desc"
              size="small"
              multiline
              rows={4}
              value={information?.message_status_desc}
              onChange={onChanageHandler}
              // placeholder="Enter name"
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Checkbox
              id="is_notifiable"
              color="secondary"
              checked={information?.is_notifiable == 1 ? true : false}
              onChange={onChanageHandler}
            />
            <Typography variant="h7" className="font-colormsg mb-1">
              Is Notifiable?
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={() => {
                createNewStatusCode();
              }}
            >
              {type == "Add" ? "  Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default StatusCodeDrawer;
